import {createContext} from 'react';

export const TimezoneContext = createContext({});
